import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import './app/shared/helpers/extension-helpers';
import './app/shared/helpers/string-extensions';
import { appConfig } from './app/app.config';
import { registerLicense } from '@syncfusion/ej2-base';

registerLicense(environment.syncfusion);

if (environment.production) {
  enableProdMode();
  bootstrapApplication(AppComponent, appConfig);
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
